import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-location-info-item',
    templateUrl: './location-info-item.component.html',
    styleUrls: ['./location-info-item.component.css'],
    imports: [TranslateModule]
})
export class LocationInfoItemComponent {
  @Input() location: string;
  @Input() mapRef: string;

  openMaps(): void {
    open(this.mapRef, '_blank').focus();
  }
}
